import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FilterUtils } from 'primeng/components/utils/filterutils';
import 'rxjs/operator/map';
import { CommonSerivce } from '../shared/services/common.service';
import { UserService } from '../shared/services/user.service';
import { jsPDF } from "jspdf";
//import * as jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Observable } from 'rxjs/Observable';
//import 'jspdf-autotable';
//import jsPDF from 'jspdf';
//import 'jspdf-autotable';
import 'rxjs/Rx';


@Component({
    selector: 'userProfile',
    styleUrls: ['../shared/share.component.css'
  ],
    providers: [CommonSerivce, UserService, DatePipe],
    templateUrl: './userProfile.component.html'
})



export class UserProfileComponent implements OnInit {

    /*
        RecordList - Search result list
        SelectedRecordList - User selected record (Multiple) in the result table
        SelectedRecord - User selected record (Single) for edition
    */
    public RecordList: IUserProfile[];
    public SelectedRecordList: IUserProfile[];
    public SelectedRecord: IUserProfile;
    public InputErrorMsg: string[];

    //  Hold the value of the user inputted search field, to be used for searching
    public SearchFieldHolder: any;
    public SearchDnFieldHolder: any;
    public cols: any;
    public exportColumns: any;
  public pdfColumns = [];
  public attachmentCols: any;



    //  Code value list for List Box, add required code value list
    public DataRoleList: IDataRole[];
    public ProcessRoleList: IProcessRole[];
    public ActiveFlagList: IListValue[];
    public AttachmentList: IAttachmentValue[];


    /*
        sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
        softF - define the sorting field name
    */
    sortO: number = 0;
    sortF: string = '';


    /*
        Major control variables
            FormTitle - Initial Form Title for the landing form
            PrimaryApiPath - Path for the API controller per component 
            ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
            AutoReload - control auto reload component
            
    */
    FormTitle: String = "Work With User Profile";
	  FormAccessRight: String = "NA";
    PrimaryApiPath: string = "api/BcpUserProfile/";
    ListValueApiPath: string = "api/BcpListValue/ByListCode/";
    AuthApiPath: string = "api/BcpJwtAuth/getDistinguishedName/";
    AttachmentPath: string = "api/BcpAttachment/";

    ShowAddForm: Boolean = false;
    ShowEditForm: Boolean = false;
    SuccessUpload: Boolean = false;
    AddMode: string = "N";

    AutoReload: Boolean = true;

	  scrollHeight: string = "";
    scrollWidth: string = "";

    httpOriginalUrl: String;
    stringifyValue = "";
    stringifyUploadValue = "";
    Headers = new HttpHeaders();
    isLoggedIn: boolean = false;

    //Attachment related
    public uploadAttachment: boolean = false;
    public record: any;
    uploadFile: File;


    //For display Edit and Delete Images
    //public imgEdit = require("../shared/Images/edit.gif");
    //public imgDelete = require("../shared/Images/delete.gif");

    //for animation status
    //animStatus: string = 'inactive';




  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string, private bcp: CommonSerivce, private datePipe: DatePipe) {
    //  this.httpHeaders = this.bcp.getHttpHeader();
    this.PrimaryApiPath = originUrl + this.PrimaryApiPath;
    this.ListValueApiPath = originUrl + this.ListValueApiPath;
    this.FormAccessRight = this.bcp.getAccessRightByProcess('USER_PROFILE');
    this.isLoggedIn = this.bcp.getLoginStatus();

    this.getListValue();
    this.getData();

    this.resetSearchField();
    this.FormTitle = "Work With User Profile";
    this.ShowAddForm = false;
    this.ShowEditForm = false;

    this.scrollHeight = this.bcp.getDataTableHeight(4);
    this.scrollWidth = this.bcp.getDataTableWidth();

    this.SelectedRecord = null;
    this.InputErrorMsg = [];


    this.cols = [
      { field: 'actions', header: 'Actions', width: '100', size: '5' },
      { field: 'id', header: 'ID', width: '100', size: '5' },
      { field: 'domainId', header: 'Domain ID', width: '200', size: '10' },
      { field: 'loginId', header: 'Login ID', width: '300', size: '10' },
      { field: 'processRole', header: 'Process Role', width: '300', size: '10' }
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
    this.pdfColumns[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);

    this.attachmentCols = [
      { field: 'actions', header: 'Actions', width: '60', size: '5' },
      { field: 'id', header: 'Id', width: '60', size: '5' },
      { field: 'sourceRecordId', header: 'Source Record Id', width: '100', size: '5' },
      { field: 'displayName', header: 'File Name', width: '100', size: '5' },
      { field: 'createDate', header: 'Create Date', width: '100', size: '5' }
    ];


  }

  ngOnInit() {

    console.log("on init");


    FilterUtils['custom'] = (value, filter): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return parseInt(filter) > value;
    };

   }


    //to get required code list from Web API
    getListValue() {
      console.log("get list value");
        //get list value  Box
      this.http.get(this.PrimaryApiPath + "GetProcessRole", this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.DataRoleList = result;
        });

      this.http.get(this.PrimaryApiPath + "GetProcessRole", this.bcp.getHttpOptions())
        .subscribe((result:  any[]) => {
          this.ProcessRoleList = result;
        });


      this.http.get(this.ListValueApiPath + this.bcp.getCurrentDomainId() + "/ACTIVE_FLAG", this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.ActiveFlagList = result;
      }); 

    }
    


    getData() {

      this.http.get(this.PrimaryApiPath, this.bcp.getHttpOptions())
          .subscribe((result:any[]) => {
            this.RecordList = result;
            console.log(this.RecordList);
          });
    }


    //get record by id and assign to selected record
    getDataById(id) {
        this.http.get(this.PrimaryApiPath + id, this.bcp.getHttpOptions())
         .subscribe((data: any) => {
           this.SelectedRecord = data;
           this.SelectedRecord.activeFlag = this.bcp.convertYesNoToBoolean(this.SelectedRecord.activeFlag);
           this.SelectedRecord.vip = this.bcp.convertYesNoToBoolean(this.SelectedRecord.vip);

            });
    }
   

    //get record by id and assign to selected record
    getDataBySearchField() {

      this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
      console.log("get data by search : " + this.stringifyValue);

      this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          console.log(this.RecordList);
        });

    }

  
    getDistinguishedName() {

        var userDN: string;

        this.SearchDnFieldHolder = JSON.parse('{"searchUserName": 0}');
        this.SearchDnFieldHolder["adminUserName"] = this.bcp.getCurrentLoginUser();
        this.SearchDnFieldHolder["adminDn"] = this.bcp.getCurrentUserDn();
        this.SearchDnFieldHolder["adminPassword"] = this.bcp.getCurrentUserPwd();
        this.SearchDnFieldHolder["searchUserName"] = this.SelectedRecord.loginId.replace("\\", "@");
        this.stringifyValue = JSON.stringify(this.SearchDnFieldHolder);
        //alert(this.stringifyValue);
        //alert(this.SelectedRecord.distinguishedName);
        this.http.post(this.AuthApiPath, this.stringifyValue, this.bcp.getHttpOptions())
          .subscribe((result: any[]) => {
                this.SelectedRecord.distinguishedName = JSON.parse(JSON.stringify(result)).UserDN;
            });
    };
    

    //Get record ID for re-direct to edit page when click 'Save and Upload' (For upload Attachment)
    getIDbyData() {
        this.http.post(this.PrimaryApiPath + "GetID/Sec/" + this.bcp.getCurrentDataRole(), this.stringifyValue, this.bcp.getHttpOptions())
            .map((response: Response) => response.json())
            .subscribe(data => {
                this.record = data;
                this.editRecord(this.record.id);
            });
    }

    exportExcel() {
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.RecordList);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "primengTable");
      });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      });
  } 


  exportPdf() {
    const doc = new jsPDF({ orientation: "landscape" });
    var head = [];
    head[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);
    autoTable(doc, {
      headStyles: { fillColor: [0,0,0] },
      styles: { fillColor: [255, 255, 0] },
      columnStyles: { 0: { halign: 'center', fillColor: [0, 255, 0] }, 1: { halign: 'left', fillColor: [0, 255, 255] } },
      head: head,
      body: this.RecordList.map(e => Object.keys(e).map(k => e[k])),
      didDrawCell: (data) => {
        //console.log(data.column.index)
      },
    });

    doc.save('table.pdf');
  }

    findRecord() {
        this.RecordList = null;
        this.getDataBySearchField();
    }


    resetSearchField() {
        //dummy field, not use for searching
        this.SearchFieldHolder = JSON.parse('{"id": 0}');

        //set default value for all search fields
        //available field, please refer to the last part of [TableName]Controller.cs
        this.SearchFieldHolder["domainId"] = "BCP";
        this.SearchFieldHolder["loginId"] = "";
        this.SearchFieldHolder["distinguishedName"] = "";
        this.SearchFieldHolder["fullName"] = "";
        this.SearchFieldHolder["dataRole"] = "";
        this.SearchFieldHolder["processRole"] = "";

    }



    addRecord() {
        //initialize the SelectedRecord as a new record, and assign default value as required
      this.SelectedRecord = null;
        this.SelectedRecord = JSON.parse('{"id": 0}');
        //set default value 
      this.SelectedRecord.domainId = "BCP";
        this.SelectedRecord.loginId = "";
        this.SelectedRecord.password = "";
        this.SelectedRecord.distinguishedName = "";
        this.SelectedRecord.department = "";
        this.SelectedRecord.title = "";
        this.SelectedRecord.email = "";
        this.SelectedRecord.phone = "";
        this.SelectedRecord.vip = "";
        this.SelectedRecord.dataRole = "NIL";
        this.SelectedRecord.processRole = "SUPPORT";
        this.SelectedRecord.activeFlag = 1;


        this.FormTitle = "User Profile Revision";
        this.ShowAddForm = true;
        this.ShowEditForm = false;
        this.AddMode = "Y";
    }

    editRecord(recordId) {
        this.SelectedRecord = null;
        this.getDataById(recordId);
        this.getAttachmentList(recordId);

        this.FormTitle = "User Profile Revision";// - ID = " + recordId;
        this.ShowAddForm = false;
        this.ShowEditForm = true;
        this.AddMode = "N";

      console.log("selected record is " + recordId);

    }

   
    saveRecord() {

        this.InputErrorMsg = [];

        //convert check box field value from boolean to character

        this.SelectedRecord.activeFlag = this.bcp.convertBooleanToYesNo(this.SelectedRecord.activeFlag);

        this.SelectedRecord.vip = this.bcp.convertBooleanToYesNo(this.SelectedRecord.vip);
        this.SelectedRecord.password = this.SelectedRecord.loginId;

        this.SelectedRecord.updateDate = this.bcp.getCurrentDateTime();
        this.SelectedRecord.updateUser = this.bcp.getCurrentLoginUser();

        this.stringifyValue = JSON.stringify(this.SelectedRecord);
        //alert(this.stringifyValue);
        if (this.SelectedRecord.id == 0) {
            this.http.post(this.PrimaryApiPath, this.stringifyValue, this.bcp.getHttpOptions())
                .subscribe(
                    (result: any) => {
                        if (this.uploadAttachment == true) {
                            this.getIDbyData();
                            //this.editRecord(this.recordId, this.SelectedRecord.staffId);
                        } else {
                            this.ShowAddForm = false;
                            this.ShowEditForm = false;
                            this.FormTitle = "Work With User Profile";
                            this.findRecord();
                        }

                },
                (err) => {
                    if (err.status === 400) {
                        // handle validation error
                        let validationErrorDictionary = JSON.parse(err.text());
                        for (var fieldName in validationErrorDictionary) {
                            if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                                this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                            }
                        }
                    } else {
                        this.InputErrorMsg.push("something went wrong!");
                    }
                });
        }
        else {
          console.log("ready to put  " + this.stringifyValue);
            this.http.put(this.PrimaryApiPath + "" + this.SelectedRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
                .subscribe(
                (result: any) => {
                        this.ShowAddForm = false;
                        this.ShowEditForm = false;
                    this.FormTitle = "Work With User Profile";
                    this.findRecord();
                },
                (err) => {
                    if (err.status === 400) {
                        // handle validation error
                        let validationErrorDictionary = JSON.parse(err.text());
                        for (var fieldName in validationErrorDictionary) {
                            if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                                this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                            }
                        }
                    } else {
                        this.InputErrorMsg.push("something went wrong!");
                    }
                });
        }




    }


    deleteRecord(pId) {
        if (window.confirm('Do you confirm to delete the selected record  ?')) {
          this.http.delete(this.PrimaryApiPath + pId, this.bcp.getHttpOptions())
                .subscribe(
                (data : any) => {
                    this.findRecord();
                });
        }
    }

    cancel() {
        this.findRecord();
        this.SelectedRecord = null;
        this.InputErrorMsg = [];

        this.ShowAddForm = false;
        this.ShowEditForm = false;
        this.FormTitle = "Work With User Profile";

    }



    //========== ========== ==========
    // Attachment Handling - Start
    //========== ========== ==========

    //set file object for upload when file is selected
    selectUploadFile(event: any) {
        //this.uploadFile = event.target.files[0];
        let fi = event.srcElement;
        if (fi.files && fi.files[0]) {
            this.uploadFile = fi.files[0];
        }
    }


    //upload the selected attachment
    processUploadFile(sourceRecordId: any) {
        //let fi = event.srcElement;
        //if (fi.files && fi.files[0]) {
       if (this.uploadFile) {
            //let fileToUpload = fi.files[0];
            var filePrefix: String;
            filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
            filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

            let fileToUpload = this.uploadFile;
            let formData: FormData = new FormData();

            formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
            formData.append("DomainId", this.bcp.getCurrentDomainId());
           formData.append("SourceTableName", "UserProfile");
           formData.append("SourceRecordId", sourceRecordId);
            formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

         let headers = new HttpHeaders();
         // DON'T SET THE Content-Type to multipart/form-data,
         //You'll get the Missing content-type boundary error
            //let options = new RequestOptions();

         this.http.post("api/BcpAttachment/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
                .subscribe(r => console.log(r));

            this.SuccessUpload = true;
        }
        if (this.SuccessUpload == true) {
          alert("Attachment Upload Successfully");
          //this.uploadFile = null;
          this.getAttachmentList(sourceRecordId);
        }
    }


    //download attachment by click on the filename
    downloadFile(recordID, fileName) {
      //this.http.get(this.AttachmentPath + "File/" + recordID, { 'responseType': 'blob'} )
      this.http.get(this.AttachmentPath + "File/" + recordID, this.bcp.getHttpOptionsAtt())
        .catch((err) => { return Observable.throw(err); })
        .subscribe((result: any) => {
               if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
                  console.log("window" + result);
                  var blob = new Blob([result]);
                  window.navigator.msSaveOrOpenBlob(blob, fileName);
              } else {
                  console.log("other" + result);

                 var a = document.createElement("a");
                 var blob = new Blob([result]);
                  a.href = URL.createObjectURL(result);
                  a.download = fileName;
                  // start download
                  a.click();
                }
            })
            
    }   

    //delete the attachment 
    deleteAttachment(recordID) {
        if (window.confirm('Do you confirm to delete the selected record  ?')) {
          this.http.delete(this.AttachmentPath + "Delete/" + recordID, this.bcp.getHttpOptions()).subscribe((result:any) => {
                this.getAttachmentList(this.SelectedRecord.id);
            });
            //alert("Attachment Deleted Successfully");
        }
    }

    //========== ========== ==========
    // Attachment Handling - End
    //========== ========== ==========

    //Re-direct from add page to edit page to upload attachment
    saveThenUploadAttachment() {
      this.uploadAttachment = true;
      this.saveRecord()
    }

    saveThenFindRecord() {
      this.uploadAttachment = false;
      this.saveRecord()
    }

    //-----Load Attachment List of employee-----
    //to get attachment list
    getAttachmentList(recordID) {
      this.http.get(this.AttachmentPath + "List/" + this.bcp.getCurrentDomainId() + "/UserProfile/" + recordID, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.AttachmentList = result;
          //console.log("aatachment " + this.AttachmentList);
        });


    }

    //sorting event trigger, default is sorting by id
    changeSort(event) {
        if (!event.order) {
            this.sortF = 'id';
        } else {
            this.sortF = event.field;
        }
    }


}


interface IUserProfile {

    id?;
    domainId?;
    loginId?;
    password?;
    distinguishedName?;
    fullName?;
    department?;
    title?;
    email?;
    phone?;
    vip?;
    processRole?;
    dataRole?;
    activeFlag?;
    updateDate?;
    updateUser?;

}

interface IDataRole {
}

interface IProcessRole {
}

interface IListValue {
}

interface IAttachmentValue {
}


interface SelectItem {
}
